import { Controller } from 'stimulus';

class HomeVideoController extends Controller {
  connect() {
    if (this.hasPlaybuttonTarget) {
      this.playbuttonTarget.addEventListener('click', () => {
        this.setVideo();
      });
    }

    if (this.hasVideoTarget) {
      this.handleControls();
    }
  }

  setVideo() {
    if (this.hasVideoTarget) {
      this.videoTarget.innerHTML = `
        <div class="hero__bg-video ratio--16-9 position-absolute absolute-center">
          <video class="no-wrap absolute-center img-fit" autoplay muted loop poster="/front_assets/img/hero/hero-poster-1280.jpg" id="home-video">
            <source src="https://player.vimeo.com/progressive_redirect/playback/715503432/rendition/720p/file.mp4?loc=external&signature=991ab411ff415559ac68cd26a286989cb6170af37a6e891ad2f29a95ce78cac1" type="video/mp4">
          </video>
        </div>
      `;
    }
  }

  handleControls() {
    this.videoTarget.addEventListener('click', () => {
      const video = document.getElementById('home-video');

      if (!video) {
        return;
      }

      if (video.paused) {
        video.play();
        return;
      }

      video.pause();
    });
  }
}

HomeVideoController.targets = [
  'playbutton',
  'video',
];

export default HomeVideoController;
